module.exports = __webpack_public_path__ + "img/wifi.1184444e.svg";